/* eslint-disable no-throw-literal */
const API_URL = "https://dcu.dev.api.jeyunvn.com/api";

// login
export const loginUser = async (email, password) => {
  try {
    const response = await fetch(`${API_URL}/User/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      throw new Error("Username or password is wrong");
    }

    return await response.json();
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};
// change pw
export const changePw = async (data) => {
  try {
    const response = await fetch(`${API_URL}/User/change-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error("Username or password is wrong");
    }

    return await response.json();
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};

// get all license
export const getAllLicense = async () => {
  try {
    const response = await fetch(`${API_URL}/LicenseConfig/getAll`);

    if (!response.ok) {
      throw new Error("Failed to fetch all license");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching all license:", error);
    throw error;
  }
};

// get license by id
export const getLicenseById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/LicenseConfig/GetById?id=${id}`);

    if (!response.ok) {
      throw new Error("Failed to fetch all license");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching all license:", error);
    throw error;
  }
};

// get all license details
export const getAllLicenseDetail = async (key) => {
  try {
    const response = await fetch(
      `${API_URL}/License/getListLicenseByKey?key=${key}`
    );

    if (!response.ok) {
      throw new Error("Failed to fetch all license");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching all license:", error);
    throw error;
  }
};

// add license
export const addNewLicense = async (obj) => {
  try {
    const response = await fetch(`${API_URL}/LicenseConfig/addLicenseConfig`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    });

    if (!response.ok) {
      throw new Error("Somthing is wrong");
    }

    return await response.json();
  } catch (error) {
    console.error("Error add:", error);
    throw error;
  }
};

// update license
export const updateLicense = async (obj) => {
  try {
    const response = await fetch(
      `${API_URL}/LicenseConfig/updateLicenseConfig`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      }
    );

    if (!response.ok) {
      throw new Error("Somthing is wrong");
    }

    return await response.json();
  } catch (error) {
    console.error("Error add:", error);
    throw error;
  }
};

// delete license
export const deleteLicense = async (id) => {
  try {
    const response = await fetch(`${API_URL}/LicenseConfig/Delete?id=${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Somthing is wrong");
    }

    return await response.json();
  } catch (error) {
    console.error("Error add:", error);
    throw error;
  }
};

// get all class
export const getAllClass = async (pageSize, pageIndex) => {
  try {
    const response = await fetch(
      `${API_URL}/Course/allCourse?pageSize=${pageSize}&pageIndex=${pageIndex}`
    );

    if (!response.ok) {
      throw new Error("Failed to fetch all class");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching all class:", error);
    throw error;
  }
};

// get all logo
export const getAllLogo = async () => {
  try {
    const response = await fetch(`${API_URL}/Logo/getAll`);

    if (!response.ok) {
      throw new Error("Failed to fetch all class");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching all class:", error);
    throw error;
  }
};

// get logo by id
export const getLogoById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/Logo/${id}`);

    if (!response.ok) {
      throw new Error("Failed to fetch all logo");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching all logo:", error);
    throw error;
  }
};

// add logo
export const addNewLogo = async (obj) => {
  try {
    const response = await fetch(`${API_URL}/Logo/addLogo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    });

    if (!response.ok) {
      throw new Error("Somthing is wrong");
    }

    return await response.json();
  } catch (error) {
    console.error("Error add:", error);
    throw error;
  }
};

// update logo
export const updateLogo = async (obj) => {
  try {
    const response = await fetch(`${API_URL}/Logo/updateLogo?id=${obj.id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    });

    if (!response.ok) {
      throw new Error("Somthing is wrong");
    }

    return await response.json();
  } catch (error) {
    console.error("Error add:", error);
    throw error;
  }
};

// delete logo
export const deleteLogo = async (id) => {
  try {
    const response = await fetch(`${API_URL}/Logo/Delete?id=${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Somthing is wrong");
    }

    return await response.json();
  } catch (error) {
    console.error("Error add:", error);
    throw error;
  }
};

// upload logo
export const uploadFileLogo = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/FileUpload/fileUpload`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Upload failed");
    }

    const data = await response.json();

    return {
      response: data,
      message: "Upload successfully!",
    };
  } catch (error) {
    throw {
      error: error.message,
      message: "Upload failed!",
    };
  }
};
